
<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="d-flex flex-row align-items-center justify-content-between w-100">
        <div class="cdc-label m-0">
          {{sourceComponent?.title}} ({{'Rules' | translate}})
        </div>
        <mat-icon class="cdc-label-icon" matTooltip="{{ 'Delete' | translate }}" (click)="onRemoveCondition()">delete</mat-icon>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div *ngFor="let rule of condition.rules;let i = index" class="d-flex flex-row align-items-center gap-1 mt-1 w-100">

    <div class="cdc-form-field col-3 col-lg-3 col-md-3">
      <mat-form-field class="mt-1 d-flex flex-column select-container component-types">
        <mat-select [(ngModel)]="rule.action" [disabled]="true">
          <mat-option value="display">
            {{ 'Display' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="cdc-form-field actif col-2 col-lg-2 col-md-2">
      <mat-form-field class="mt-1 d-flex flex-column select-container component-types">
        <mat-select [(ngModel)]="rule.operatorType" panelClass="operator-select" [disabled]="(sourceComponent?.type === ComponentType.INPUT && (sourceComponent?.config?.inputType === InputType.COLOR_PICKER || sourceComponent?.config?.inputType === InputType.FILE || sourceComponent?.config?.inputType === InputType.DATE)) || sourceComponent?.type == ComponentType.CHECKBOX">
          <mat-option *ngFor="let option of operatorTypes" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- INPUT -->
    <div class="cdc-form-field actif col-6 col-lg-6 col-md-6" *ngIf="sourceComponent?.type === ComponentType.INPUT && (sourceComponent?.config?.inputType === InputType.TEXT || sourceComponent?.config?.inputType === InputType.TEXT_AREA)">
      <input matInput type="text" placeholder="*" [(ngModel)]="rule.value">
    </div>

    <div class="cdc-form-field actif col-6 col-lg-6 col-md-6" *ngIf="sourceComponent?.type == ComponentType.INPUT && sourceComponent?.config?.inputType == InputType.NUMBER">
      <input matInput type="number" placeholder="{{ 'Value' | translate }}" [(ngModel)]="rule.value" (ngModelChange)="rule.value = $event?.toString()">
    </div>

    <!-- COLOR_PICKER / FILE / DATE -->
    <div class="cdc-form-field actif col-6 col-lg-6 col-md-6" *ngIf="sourceComponent?.type === ComponentType.INPUT && (sourceComponent?.config?.inputType === InputType.COLOR_PICKER || sourceComponent?.config?.inputType === InputType.FILE || sourceComponent?.config?.inputType === InputType.DATE)">
      <input matInput type="text" [(ngModel)]="rule.value" disabled="true">
    </div>

    <!-- SELECT -->
    <div class="cdc-form-field actif col-6 col-lg-6 col-md-6" *ngIf="sourceComponent?.type == ComponentType.SELECT">
      <mat-form-field class="mt-1 d-flex flex-column select-container component-types">
        <mat-select [(ngModel)]="rule.value" (click)="$event.stopPropagation()">
          <mat-option *ngFor="let option of optionsEntries" [value]="option.value"
            [tippy]="isHtml(option.display) ? option.display : ''" placement="left" theme="light-white">
            {{ stripHtml(option.display) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- CHECKBOX -->
    <div class="cdc-form-field actif col-6 col-lg-6 col-md-6" *ngIf="sourceComponent?.type == ComponentType.CHECKBOX">
      <select [(ngModel)]="rule.value" inactif matNativeControl>
        <option *ngFor="let option of booleanOptions | keyvalue" [value]="option.key">{{ option.value }}</option>
      </select>
    </div>

    <button class="col-1 col-lg-1 col-md-1" mat-icon-button (click)="onRemoveRule(i)" matTooltip="{{ 'Delete' | translate }}">
      <mat-icon>remove_circle</mat-icon>
    </button>
  </div>

  <button mat-icon-button (click)="onAddRule()" matTooltip="{{ 'Add rule' | translate }}">
    <mat-icon>add_circle</mat-icon>
  </button>
</mat-expansion-panel>
